import React, {Component, Suspense} from 'react';
import {Switch, Redirect, Route} from 'react-router-dom';
import Loadable from 'react-loadable';
import PNotify from 'pnotify/dist/es/PNotify';
import '../../node_modules/font-awesome/scss/font-awesome.scss';

import Loader from './layout/Loader'
import Aux from "../hoc/_Aux";
import ScrollToTop from './layout/ScrollToTop';
import routes from '../route';

const AdminLayout = Loadable({
    loader: () => import('./layout/AdminLayout'), loading: Loader
});

const Login = Loadable({
    loader: () => import('../FCS/Login'), loading: Loader
});

const JuradoView = Loadable({
    loader: () => import('../FCS/Modules/Jurado'), loading: Loader
});


const user = localStorage.getItem('USER_ID') || '';

const WARN_BEFORE_MS = 1 * 60 * 1000;

function parseJwt(token) {
    try {
        const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        ));
    } catch (_) {
        return null;
    }
}

class App extends Component {

    componentDidMount() {
        this.scheduleSessionWarning();
    }

    componentWillUnmount() {
        if (this.warnTimer) clearTimeout(this.warnTimer);
        if (this.expireTimer) clearTimeout(this.expireTimer);
    }

    scheduleSessionWarning() {
        const token = localStorage.getItem('TOKEN');
        if (!token) return;
        const payload = parseJwt(token);
        if (!payload || !payload.exp) return;

        const expiresAtMs = payload.exp * 1000;
        const now = Date.now();
        const msUntilWarn = expiresAtMs - WARN_BEFORE_MS - now;
        const msUntilExpire = expiresAtMs - now;

        if (msUntilWarn > 0) {
            this.warnTimer = setTimeout(() => this.showWarning(), msUntilWarn);
        } else if (msUntilExpire > 0) {
            this.showWarning();
        }

        if (msUntilExpire > 0) {
            this.expireTimer = setTimeout(() => {
                localStorage.clear();
                window.location.href = '/login';
            }, msUntilExpire);
        }
    }

    showWarning() {
        PNotify.notice({
            title: 'Tu sesión está por caducar',
            text: 'Te quedan menos de 10 minutos. Guarda tus cambios y vuelve a iniciar sesión.',
            hide: false,
            sticker: false,
            closer: true,
            delay: 0,
        });
    }

    render() {

        const menu = routes.map((route, index) => {
            return (route.component) ? (<Route
                key={index}
                path={route.path}
                exact={route.exact}
                name={route.name}
                render={props => (<route.component {...props} />)}/>) : (null);
        });

        return (

            <Aux>
                <ScrollToTop>
                    <Suspense fallback={<Loader/>}>
                        <Switch>
                            {/* Ruta pública del jurado — siempre accesible, sin importar el estado de sesión */}
                            <Route path="/jurado/:token" exact component={JuradoView}/>

                            {
                                user !== "" ?
                                    <>

                                        {menu}

                                        <Route path="/" component={AdminLayout}/>
                                    </> : <>
                                        <Route path="/login" exact component={Login}/>
                                        <Redirect to="/login"/>
                                    </>}

                        </Switch>
                    </Suspense>
                </ScrollToTop>
            </Aux>);


    }
}

export default App;
